<template>
  <div class="font-family">
    <div
      class="menu-title"
      @click.stop="showFontFamilyPopup($event)"
    >
      <span>{{currentFont.label || '方正黑体'}}</span>
      <i class="tri"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      currentFont: {
        value: '2018-5-16/1526467728442.TTF',
        filename: '1526467728442.TTF',
        label: '方正黑体'
      }
    }
  },
  computed: {
    ...mapGetters({
      subtitle: 'subtitle/selectSubtitle'
    })
  },
  created () {
    this.$bus.on('font', (font, from) => {
      if (from === 'wordCloud') {
        let filename = font.value.replace(/.+\//, '');
        this.$store.commit('subtitle/updateSubtitleUndo', {
          subtitle: {
            font: {
              fontFamilyUrl: font.value,
              fontFamilyLabel: font.label,
            }
          }
        });
      }
    });

    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.font.fontFamilyUrl
      }
    }, function (val, oldVal) {
      Object.assign(this.currentFont, {
        value: val,
      });
    });

    this.$watch(function () {
      if (this.subtitle) {
        return this.subtitle.font.fontFamilyLabel
      }
    }, function (val, oldVal) {
      Object.assign(this.currentFont, {
        label: val
      });
    });

    eve.on('updateSubtitleEve', () => {
      if (!this.subtitle || !this.subtitle.font) {
        return;
      }
      let label = this.subtitle.font.fontFamilyLabel;
      Object.assign(this.currentFont, {
        label: label
      });
    });

    document.body.addEventListener('click', this.onBodyClicked)
  },
  methods: {
    showFontFamilyPopup (ev) {
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('subtitlePopup', {
        name: 'fontFamily',
        // initialX: rect.left,
        // initialY: rect.top + 10,
        posx: rect.left,
        posy: rect.top + 10,
        type: 1,
        // sprite: this.sprite,
        // source: this.$parent
        from: 'wordCloud',
        refFont: this.currentFont
      });
    },
    onBodyClicked (ev) {
      this.$bus.emit('subtitlePopupClose', {
        name: 'fontFamily',
        type: 1,
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 10px;
  width: 226px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  font-size: 12px;
  color: #737596;
  cursor: pointer;
}
.tri {
  border-top: 6px solid #737596;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 0 solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/fontFamily.vue